import { FC } from 'react';

import { Typography } from '@mui/material';

import { styles } from './styles';

export const OnDragFileLabel: FC = () => {
  return <Typography sx={{ ...styles.label }}>Drop your files here</Typography>;
};
